export default __webpack_public_path__ + "static/media/okex-logo.4df2a303.png";